// extracted by mini-css-extract-plugin
export default {"buttons":"ReceivableInitializationComponent_buttons__you+A","button":"ReceivableInitializationComponent_button__SHo3r"};